export const LocationService = {

    getHref() {
        return globalThis.location.href;
    },

    setHref: (href: string) => {
        globalThis.location.href = href;
    },

    getPathname() {
        return globalThis.location.pathname;
    }
}